module.exports = __webpack_public_path__ + "img/tbt828-1993.asm.96cafea5.jpg";